import styled from 'styled-components';

export const Container = styled.div`
  .rule,
  .ruleGroup {
    gap: 8px !important;
    border: 0 !important;
    background-color: transparent !important;
  }

  .rule.dndOver {
    border-bottom: 2px dotted #ccc !important;
  }

  .ruleGroup-header > .queryBuilder-dragHandle,
  .ruleGroup-header > .ruleGroup-cloneGroup,
  .ruleGroup-header > .ruleGroup-remove {
    display: none !important;
  }

  .ruleGroup-body {
    gap: 0 !important;

    .rule {
      padding: 8px 0 !important;
      align-items: start !important;
      background-color: #fff !important;

      .error-message {
        margin-top: 8px;
      }

      .delete-icon,
      .clone-icon,
      .copy-icon {
        cursor: none;
        opacity: 0 !important;
      }

      &:hover {
        .delete-icon,
        .clone-icon,
        .copy-icon {
          cursor: pointer;
          opacity: 1 !important;
        }
      }

      .copy-icon,
      .clone-icon,
      .delete-icon,
      .prompt-icon,
      .queryBuilder-dragHandle {
        margin-top: 8px !important;
      }
    }
  }

  .queryBuilder > .ruleGroup {
    padding: 0 !important;
  }
`;

export const Combinator = styled.span`
  color: #999;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0;
  height: 32px;
`;

export const ErrorMessage = styled.div`
  line-height: 1;
  color: rgb(202 34 22);
  font-size: 14px;
`;
